import createReducer from 'reducers/createReducer';

import { TournamentList } from 'actions/actionTypes';

const INITIAL_STATE = {
  filterData: {
    page: 1,
    pageSize: 10,
    tournamentStatus: 0,
    tournamentTypeCode: '',
  },
  data: {},
  tournamentId: 0,

  isDeleteRequestSuccess: null,
  isEarlyEndRequestSuccess: null,

  error: {
    triggered: false,
    message: '',
  },
};

const reducer = createReducer(INITIAL_STATE, {
  // 이벤트
  [TournamentList.CHANGE_TOURNAMENT_LIST_FILTER_DATA]: (state, action) => {
    const { name, value } = action.payload;

    if (name === 'tournamentTypeCode') {
      state.filterData = {
        ...INITIAL_STATE.filterData,
        tournamentTypeCode: value,
      };
    } else {
      state.filterData[name] = value;
    }
  },

  // 매장 대회 목록 조회
  [TournamentList.LOAD_TOURNAMENT_LIST_REQUEST]: (state, action) => {
    state.isDeleteRequestSuccess = null;
    state.isEarlyEndRequestSuccess = null;

    state.error = INITIAL_STATE.error;
  },
  [TournamentList.LOAD_TOURNAMENT_LIST_REQUEST_SUCCESS]: (state, action) => {
    state.data = action.payload;
  },
  [TournamentList.LOAD_TOURNAMENT_LIST_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 삭제
  [TournamentList.DELETE_TOURNAMENT_REQUEST]: (state, action) => {
    state.isDeleteRequestSuccess = null;

    state.error = INITIAL_STATE.error;
    state.tournamentId = action.payload.tournamentId;
  },
  [TournamentList.DELETE_TOURNAMENT_REQUEST_SUCCESS]: (state, action) => {
    state.isDeleteRequestSuccess = true;

    state.tournamentId = INITIAL_STATE.tournamentId;
  },
  [TournamentList.DELETE_TOURNAMENT_REQUEST_FAILURE]: (state, action) => {
    state.isDeleteRequestSuccess = false;

    state.tournamentId = INITIAL_STATE.tournamentId;

    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 조기 종료
  [TournamentList.EARLY_TOURNAMENT_REQUEST]: (state, action) => {
    state.isEarlyEndRequestSuccess = null;

    state.error = INITIAL_STATE.error;
    state.tournamentId = action.payload.tournamentId;
  },
  [TournamentList.EARLY_TOURNAMENT_REQUEST_SUCCESS]: (state, action) => {
    state.isEarlyEndRequestSuccess = true;

    state.tournamentId = INITIAL_STATE.tournamentId;
  },
  [TournamentList.EARLY_TOURNAMENT_REQUEST_FAILURE]: (state, action) => {
    state.isEarlyEndRequestSuccess = false;

    state.tournamentId = INITIAL_STATE.tournamentId;

    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },
});

export default reducer;
